import { Skeleton } from "@shared-ui/skeleton";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuthStore } from "@/features/auth/store/admin-auth.store";
import { ADMIN_AUTH_EVENT } from "@/lib/token-manager";

export function ProtectedAdminRoute({
	children,
}: {
	children: React.ReactNode;
}) {
	const location = useLocation();
	const {
		operator,
		isBootstrapping,
		bootstrap,
		hasStoredSession,
		clearSession,
	} = useAdminAuthStore();
	const hasSession = hasStoredSession();

	useEffect(() => {
		if (!operator && hasSession) {
			void bootstrap();
		}
	}, [bootstrap, hasSession, operator]);

	useEffect(() => {
		const handleAuthChange = () => {
			if (!useAdminAuthStore.getState().hasStoredSession()) {
				clearSession();
			}
		};

		window.addEventListener(ADMIN_AUTH_EVENT, handleAuthChange);
		return () => window.removeEventListener(ADMIN_AUTH_EVENT, handleAuthChange);
	}, [clearSession]);

	if (isBootstrapping) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-background p-6">
				<div className="grid w-full max-w-3xl gap-4">
					<Skeleton className="h-16 w-full rounded-2xl" />
					<Skeleton className="h-72 w-full rounded-3xl" />
				</div>
			</div>
		);
	}

	if (!operator || !hasSession) {
		return <Navigate to="/login" replace state={{ from: location.pathname }} />;
	}

	return <>{children}</>;
}
